<template>
  <div id="app">
    <router-view/>
    <loader ></loader>
  </div>
</template>

<script>
export default {
  name: "App",
  metaInfo: {
  },
  computed: {},
};
</script>

<style lang="scss">
@import "/assets/scss/style";
body{
}
#app {
  font-family: $RobotoRegular, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
// Знаю, косяк, потом придумаю как поправить
// TODO: да да
div.v--modal-overlay{
  z-index: 1020;
}

</style>
